@if (canShowDrawer) {
  <div
    class="report-drawer-sidebar"
    [class.report-mode]="isCreateReportMode$ | async"
    [style.marginRight]="hasVisibleScrollBar ? drawerScrollbarMargin : drawerNonReportSize"
    [style.width]="(isCreateReportMode$ | async) ? ((isDrawerExpanded$ | async) ? drawerExpandedSize : drawerCollapsedSize) : drawerNonReportSize"
    [attr.aria-hidden]="isCreateReportDrawerHidden"
    >
    @if (isDrawerExpanded$ | async) {
      <ng-container [ngTemplateOutlet]="ExpandedSideBar"> </ng-container>
    } @else {
      <div class="drawer-collapsed">
        <div class="panel-header">
          <div class="buttonset">
            <button
              [attr.data-automation-id]="DrawerConstants.Button.collapseId"
              [disabled]="isCreateReportDrawerHidden"
              soho-button="icon"
              icon="collapse-app-tray"
              title="{{ DrawerConstants.Button.expand | translate }}"
              (click)="onExpand(true)"
            ></button>
          </div>
          <div class="title">
            <span
              ><b>{{ DrawerConstants.title | translate }}</b></span
              >
              @if ((selectedFields$ | async).size > 0) {
                <span class="round success badge lm-bounce">{{ (selectedFields$ | async).size }}</span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Sidebar Templates -->
  <ng-template #ExpandedSideBar>
    <div class="drawer-expanded" [attr.aria-hidden]="isCreateReportDrawerHidden">
      <div class="panel-header">
        <div class="toolbar">
          <div class="title">
            <span>{{ DrawerConstants.title | translate }}</span>
          </div>
          <div class="buttonset">
            <button
              soho-button="icon"
              icon="expand-app-tray"
              [attr.data-automation-id]="DrawerConstants.Button.expandId"
              [disabled]="isCreateReportDrawerHidden"
              title="{{ DrawerConstants.Button.collapse | translate }}"
              (click)="onExpand(false)"
            ></button>
            <button
              soho-button="icon"
              icon="close-small"
              [attr.data-automation-id]="DrawerConstants.Button.cancelId"
              [disabled]="isCreateReportDrawerHidden"
              title="{{ DrawerConstants.Button.cancel | translate }}"
              (click)="onClose()"
            ></button>
          </div>
        </div>
      </div>

      <div class="viewer-container">
        @if (!isCreateReportDrawerHidden) {
          <lm-report-field-picker-viewer></lm-report-field-picker-viewer>
        }
      </div>

      <div class="row">
        <div class="container">
          <div class="field">
            <button
              [attr.data-automation-id]="DrawerConstants.Button.addToExistingReportId"
              soho-button="secondary"
              title="{{ DrawerConstants.Button.addToExistingReportTitle | translate }}"
              [disabled]="(selectedFields$ | async).size === 0"
              (click)="onAddToExistingReport()"
              >
              {{ DrawerConstants.Button.addToExistingReportLabel | translate }}
            </button>
          </div>
          <div class="field">
            <button
              [attr.data-automation-id]="DrawerConstants.Button.createNewReportId"
              soho-button="primary"
              title="{{ DrawerConstants.Button.createNewReportTitle | translate }}"
              [disabled]="(selectedFields$ | async).size === 0"
              (click)="onCreateNewReport()"
              >
              {{ DrawerConstants.Button.createNewReportLabel | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

